__turbopack_context__.v({
  "icon": "IconBadge-module-scss-module__E1E_Oa__icon",
  "usage-content": "IconBadge-module-scss-module__E1E_Oa__usage-content",
  "usage-indicator": "IconBadge-module-scss-module__E1E_Oa__usage-indicator",
});
